"use strict";
/*
 * Created on 09 07 2020
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var PriceTerminationUploadedItem_1 = require("../../../price-termination/model/PriceTerminationUploadedItem");
/**
 * @author Jaroslav Sevcik
 */


var SiteReleaseTerminationUploadedItem =
/*#__PURE__*/
function (_PriceTerminationUplo) {
  _inherits(SiteReleaseTerminationUploadedItem, _PriceTerminationUplo);

  function SiteReleaseTerminationUploadedItem() {
    _classCallCheck(this, SiteReleaseTerminationUploadedItem);

    return _possibleConstructorReturn(this, _getPrototypeOf(SiteReleaseTerminationUploadedItem).apply(this, arguments));
  }

  return SiteReleaseTerminationUploadedItem;
}(PriceTerminationUploadedItem_1.PriceTerminationUploadedItem);

exports.SiteReleaseTerminationUploadedItem = SiteReleaseTerminationUploadedItem;